import React, { useState } from 'react';
import c from 'classnames';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

import {
  DEFAULT_CV_INSTALLATION_COST,
  DEFAULT_CV_MAINTENANCE_COST,
  DEFAULT_GAS_CONSUMPTION,
  DEFAULT_GAS_FIXED_COST,
  DEFAULT_GAS_GRID_MANAGEMENT_COST,
  DEFAULT_GAS_PRICE,
  SENTRY_DSN,
} from '../../config/constants';
import HeatCalculator from '../HeatCalculator';
import GasCalculator from '../GasCalculator';
import DataContext from '../../contexts/DataContext';
import ModalContext from '../../contexts/ModalContext';
import { APP_ENV } from '../../../../shared/config/constants';

if (APP_ENV !== 'development' && APP_ENV !== 'ci') {
  Sentry.init({
    dsn: String(SENTRY_DSN),
    integrations: [new Integrations.BrowserTracing()],
    attachStacktrace: true,
    tracesSampleRate: 1.0,
    environment: APP_ENV,
    allowUrls: [/^https?:\/\/[^/]+\/libraries\/hvc_widgets\//],
  });
}

const App = () => {
  const classNames = c('App');

  const [gasConsumption, setGasConsumption] = useState(DEFAULT_GAS_CONSUMPTION);
  const [gasPrice, setGasPrice] = useState(DEFAULT_GAS_PRICE);
  const [
    gasGridManagementCost,
    setGasGridManagementCost,
  ] = useState(DEFAULT_GAS_GRID_MANAGEMENT_COST);
  const [gasFixedCost, setGasFixedCost] = useState(DEFAULT_GAS_FIXED_COST);
  const [cvInstallationCost, setCvInstallationCost] = useState(DEFAULT_CV_INSTALLATION_COST);
  const [cvMaintenanceCost, setCvMaintenanceCost] = useState(DEFAULT_CV_MAINTENANCE_COST);

  const [modalOpen, setModalOpen] = useState(false);

  // TODO: Remove this eslint-disable line and fix the linting issue.
  // eslint-disable-next-line react/jsx-no-constructed-context-values
  const dataContextData = {
    gasConsumption,
    gasPrice,
    gasGridManagementCost,
    gasFixedCost,
    cvInstallationCost,
    cvMaintenanceCost,
    updateGasConsumption: setGasConsumption,
    updateGasPrice: setGasPrice,
    updateGasGridManagementCost: setGasGridManagementCost,
    updateGasFixedCost: setGasFixedCost,
    updateCvInstallationCost: setCvInstallationCost,
    updateCvMaintenanceCost: setCvMaintenanceCost,
  };

  // TODO: Remove this eslint-disable line and fix the linting issue.
  // eslint-disable-next-line react/jsx-no-constructed-context-values
  const modalContextData = {
    modalOpen,
    updateModalOpen: setModalOpen,
  };

  return (
    <DataContext.Provider
      value={dataContextData}
    >
      <ModalContext.Provider
        value={modalContextData}
      >
        <div className={classNames}>
          <main className="main">
            <HeatCalculator />
          </main>
          <div id="modal-root">
            {modalOpen && <GasCalculator />}
          </div>
        </div>
      </ModalContext.Provider>
    </DataContext.Provider>
  );
};

export default App;
